import * as React from "react";
import type { SVGProps } from "react";
const SvgIconMonitor = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" style={{
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  fillRule: "evenodd",
  clipRule: "evenodd"
}} viewBox="0 0 3287.47 1607.2" {...props}><g><path fill="#56C75E" d="M-0 1607.2l3287.47 0 0 -1607.2c-145.46,76.97 -249.05,117.16 -405.57,178.86 -368.01,145.09 -665.7,378.95 -971.14,563.01 -99.12,59.74 -119.86,90.95 -195.02,133.74 -109.12,62.11 -314.08,97.57 -474.68,109.75 -318.12,24.13 -685.09,134.27 -918.56,323.38 -64.83,52.5 -287.94,246.88 -322.49,298.47z" /></g></svg>;
export default SvgIconMonitor;